export default __webpack_public_path__ + "static/media/product-detail-image-main.5108a392.svg";